import { object, string, boolean } from "yup";

export default object().shape({
    state: boolean().required("State is required"),
    name_en: string().min(2, "English Name must be at least 2 characters").required("English Name is required"),
    name_ar: string().min(2, "Arabic Name must be at least 2 characters").required("Arabic Name is required"),
    contactName: string(),
    contactEmail: string().email(),
    contactPhone: string(),
    contactPosition: string(),
});
